/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ImpersonateDataParser = /* #__PURE__ */ parsers.object([
    ['username', codecString],
    ['tenantId', codecString, 'tenant_id'],
    ['ownPassword', codecString, 'own_password'],
    [
        'confirmSessionTermination',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'confirm_session_termination',
    ],
]);
export class ImpersonateData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ImpersonateDataParser.decode(input).map(res => new ImpersonateData(res));
    }
    static unsafeDecode(input) {
        return ImpersonateData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ImpersonateDataParser.encode(data);
    }
    static schema() {
        return ImpersonateDataParser.schema();
    }
}
